import { useEffect } from 'react';
import UserInfoField from './UserInfoField';
import ProfileActions from './ProfileActions';
import { useDispatch, useSelector } from '../redux/hooks';
import { updateField, setProfile } from '../redux/slices/profileSlice';
import { HorizontalAd } from './HorizontalAd';
import { styled } from 'styled-components';
  
const ContentContainer = styled.main`
  max-width: 1140px;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 0 10px;
  
  @media (min-width: 768px) {
    padding: 0 20px;
  }
`;

const UserProfile: React.FC = () => {
  const dispatch = useDispatch();
  const { firstName, lastName, email, phone, isEditing } = useSelector(state => state.profile);
  const { accessToken, customer_id } = useSelector(state => state.auth);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BASE_API_URL}/profile/me`, {
          credentials: 'include',
          headers: {
            'Authorization': `Bearer ${accessToken}`,
          },
        });

        if (!res.ok) throw new Error('Failed to fetch profile');

        const data = await res.json();
        dispatch(setProfile({
          firstName: data.first_name,
          lastName: data.second_name,
          email: data.email,
          phone: data.phone,
        }));
      } catch (err) {
        console.error(err);
      }
    };

    fetchProfile();
  }, [dispatch, accessToken, customer_id]);

  return (
    <ContentContainer>
      <HorizontalAd imageUrl={`${process.env.PUBLIC_URL}/media/horizontal_ad.png`} />
      <UserInfoField
        label="Прізвище"
        value={lastName}
        onChange={(e) => dispatch(updateField({ field: 'lastName', value: e.target.value }))}
        disabled={!isEditing}
      />
      <UserInfoField
        label="Ім’я"
        value={firstName}
        onChange={(e) => dispatch(updateField({ field: 'firstName', value: e.target.value }))}
        disabled={!isEditing}
      />
      <UserInfoField
        label="Email"
        value={email}
        onChange={(e) => dispatch(updateField({ field: 'email', value: e.target.value }))}
        disabled={!isEditing}
      />
      <UserInfoField
        label="Телефон"
        value={phone}
        onChange={(e) => dispatch(updateField({ field: 'phone', value: e.target.value }))}
        disabled={!isEditing}
      />
      <ProfileActions />
      <HorizontalAd imageUrl={`${process.env.PUBLIC_URL}/media/horizontal_ad.png`} />
    </ContentContainer>
  );
};

export default UserProfile;
